import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('click', '[data-finishings]', function() {
  return $.ajax({
    method: 'GET',
    url: $(this).attr('data-finishings'),
  }).done((resp) => {
    $(resp).foundation().foundation('open');
  });
});

$(document).on(
  'submit.addCartPosition',
  '[data-add-cart-finished-position], [data-update-finished-position]',
  function(event) {
    event.preventDefault();

    $(this)
      .find('input[name="itemunit"]:not(:checked)')
      .closest('.finishing__unit')
      .find('input[type="number"], input[type="hidden"]')
      .attr('disabled', 'disabled');

    let store = 'cart';
    if ($(this).attr('data-update-finished-position') === 'list') {
      store = 'shoppinglist';
    }

    const $form = $(this).closest('form');
    const $reveal = $(this).closest('.reveal');
    const data = $form.serializeArray();
    data.push({ name: 'render', value: $(`[data-bind-html="${store}:html"]`).length ? 1 : 0 });
    data.push({ name: 'calculate', value: $(`[data-bind-html="${store}:html"]`).length ? 1 : 0 });
    return load(
      $reveal,
      $.stores[store].post($form.attr('action'), data).then(() => {
        $reveal.foundation('close');
      }),
    );
  },
);

$(document)
  .off('submit', '[data-add-shoppinglist-position]')
  .on('submit', '[data-add-shoppinglist-position]', function(event) {
    event.preventDefault();
    event.stopPropagation();

    const $form = $(this);
    const data = $form.serializeArray();
    if ($('[data-bind-html="shoppinglist:html"]').length) {
      data.push({ name: 'render', value: 1 });
      data.push({ name: 'calculate', value: 1 });
    }
    const $reveal = $(this).closest('.reveal');
    load(
      $reveal,
      $.stores.shoppinglist.post($form.attr('action'), data).then(() => {
        $reveal.foundation('close');
      }),
    );
  });

$(document).on('click', '[data-add-finished-to-shoppinglist]', function (event) {
  event.preventDefault();
  $(this)
    .closest('form')
    .find('input[name="itemunit"]:not(:checked)')
    .closest('.finishing__unit')
    .find('input[type="number"], input[type="hidden"]')
    .attr('disabled', 'disabled');

  const $reveal = $(this).closest('.reveal');
  return load(
    $reveal,
    $.ajax({
      method: 'POST',
      url: $(this).attr('data-add-finished-to-shoppinglist'),
      data: $(this).closest('form').serialize(),
    }).then((resp) => {
      $reveal.foundation('close');
      const element = $(resp).foundation();
      element.foundation('open');
    }),
  );
});

$(document).on('submit', '[data-add-shoppinglist-finished-position]', function(event) {
  event.preventDefault();
  event.stopPropagation();
  let qty = $(this).find('[data-add-shoppinglist-position-quantity]').first();
  if (qty.length === 0) {
    qty = $(this).find('input[name="quantity"]').first();
  }
  const store = 'shoppinglist';
  const $form = $(this).closest('form');
  const $reveal = $(this).closest('.reveal');
  const data = $form.serializeArray();
  data.push({ name: 'render', value: $(`[data-bind-html="${store}:html"]`).length ? 1 : 0 });
  data.push({ name: 'calculate', value: $(`[data-bind-html="${store}:html"]`).length ? 1 : 0 });
  return load(
    $reveal,
    $.stores[store].post($form.attr('action'), data).then(() => {
      $reveal.foundation('close');
    }),
  );
});

$(document).on('input', '[data-finishing-quantity]', function() {
  $('[data-finishing-unit-radio]').each(function() {
    this.checked = false;
  });
  $(this).closest('.finishing__unit').find('[data-finishing-unit-radio]').get(0).checked = true;
});

$(document).on('change', '[data-mitre-cuts-toggle]', function() {
  $('[data-mitre-cuts]').toggle(this.checked);
});

$(document).on('change', '[data-mitre-cut-angle]', function() {
  if (parseFloat($(this).val()) > 60) {
    $(this).val('60');
  }
});

$(document).on('change', '[data-mitre-cut-angles-toggle]', () => {
  $('[data-mitre-cut-angles]').hide().find('input').attr('disabled', true);
  $('[data-mitre-cut-angles-toggle]:checked')
    .closest('[data-mitre-cut]')
    .find('[data-mitre-cut-angles]')
    .show()
    .find('input')
    .attr('disabled', false);
});

$(document).on('change', '[data-cutting-type-toggle]', function() {
  if (this.checked) {
    $('[data-cutting-type-toggle]').not($(this)).each(function() {
      this.checked = false;
    });
  }
});
